import {API, Setup} from '../../Services';

async function NewMessageCount_api(){
    let mallId= localStorage.getItem('mallId');
    let token= localStorage.getItem('token');
    let url = `messaging/merchant_messages/${mallId}/count?is_seen=false`
    return API.get(url,{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}

async function getCard_api(){
    let mallId= localStorage.getItem('mallId');
    let token= localStorage.getItem('token');
    let url = `users/malls/${mallId}/card-points`
    return API.get(url,{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}



export {NewMessageCount_api,getCard_api};
